import * as React from 'react';

export const MenuTopBar = () => {
	return (
		<div className="nav-top-bar-navigation-items">
			{/* <Link to="/ingresos">Ingresos</Link>
			<Link to="/egresos">Egresos</Link>
			<Link to="/caja">Caja</Link>
			<Link to="/compras">Compras</Link> */}
		</div>
	);
};
